import axios from "../axios";

const fetchTypeCollection = "FETCH_TYPE_COLLECTION";
const fetchJobInfo = "FETCH_JOB_INFO";

let defaultValue = {
  jobInfo: [],
  typeCollection: []
};

// Reducers
export default function Reducer(state = defaultValue, action) {
  switch (action.type) {
    case fetchTypeCollection:
      return {
        ...state,
        typeCollection: action.payload
      };
    case fetchJobInfo:
      return {
        ...state,
        jobInfo: action.payload
      };
    default:
      return state;
  }
}

// Actions
/**
 * 拉取职位详情
 * @param  {[String]} id [_id字段]
 */
export const createFetchJobInfo = id => dispatch => {
  axios.get(`/api/jobInfo?id=${id}`).then(({ data }) => {
    dispatch({
      type: fetchJobInfo,
      payload: data.info
    });
  });
};

/**
 * 拉取职位类型
 */
export const createFetchTypeCollection = () => dispatch => {
  axios.get("/api/typeCollection").then(({ data }) => {
    dispatch({
      type: fetchTypeCollection,
      payload: data.types
    });
  });
};



// WEBPACK FOOTER //
// ./src/redux/EditJob.jsx